/* Latte Milky - animaciones de entrada.
   Revela con IntersectionObserver. Sin librerias.
   Contrato de marcado:
     [data-lt-reveal]          raiz observada. "now" = revela al cargar.
     [data-lt-item]            elemento que anima (valor "foto" = 16px).
     [data-lt-stagger]         contenedor: sus hijos directos animan en cascada.
     [data-lt-delay="120"]     fuerza el retardo en ms de ese elemento.
   Red de seguridad: si algo falla se quita .lt-anim de <html> y todo
   el contenido vuelve a ser visible. */

(() => {
  const doc = document.documentElement;
  const STEP = 70;
  const MAX_DELAY = 420;
  const DURATION = 620;

  const collect = (root) => {
    const found = [];
    if (root.matches('[data-lt-item]')) found.push(root);
    root.querySelectorAll('[data-lt-item], [data-lt-stagger] > *').forEach((el) => {
      if (!found.includes(el)) found.push(el);
    });
    return found;
  };

  /* Devuelve el elemento a su estado natural: primero se quita el
     selector que lo ocultaba, despues la clase. Nunca al reves. */
  const finish = (root, els) => {
    root.removeAttribute('data-lt-stagger');
    root.querySelectorAll('[data-lt-stagger]').forEach((c) => c.removeAttribute('data-lt-stagger'));
    els.forEach((el) => {
      el.removeAttribute('data-lt-item');
      el.classList.remove('lt-in');
      el.style.transitionDelay = '';
    });
  };

  const reveal = (root) => {
    if (root.dataset.ltDone === '1') return;
    root.dataset.ltDone = '1';
    const els = collect(root);
    let last = 0;
    els.forEach((el, i) => {
      const forced = el.getAttribute('data-lt-delay');
      const delay = forced === null ? Math.min(i * STEP, MAX_DELAY) : parseInt(forced, 10) || 0;
      if (delay > last) last = delay;
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('lt-in');
    });
    window.setTimeout(() => finish(root, els), last + DURATION + 260);
  };

  /* Quita el estado oculto sin animar (reduced motion / sin soporte). */
  const revealInstant = (root) => {
    root.dataset.ltDone = '1';
    finish(root, collect(root));
  };

  const start = (scope) => {
    const roots = scope.querySelectorAll('[data-lt-reveal]');
    if (!roots.length) return;

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      roots.forEach(revealInstant);
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          reveal(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    roots.forEach((root) => {
      const box = root.getBoundingClientRect();
      if (root.dataset.ltReveal === 'now' || box.top < window.innerHeight * 0.94) {
        reveal(root);
      } else {
        io.observe(root);
      }
    });

    /* Huerfanos: cualquier item fuera de una raiz nunca se observaria. */
    scope.querySelectorAll('[data-lt-item], [data-lt-stagger]').forEach((el) => {
      if (!el.closest('[data-lt-reveal]')) {
        el.removeAttribute('data-lt-item');
        el.removeAttribute('data-lt-stagger');
      }
    });
  };

  try {
    doc.classList.add('lt-anim-ready');
    start(document);
    document.addEventListener('shopify:section:load', (event) => {
      try {
        start(event.target);
      } catch (err) {
        doc.classList.remove('lt-anim');
      }
    });
  } catch (err) {
    doc.classList.remove('lt-anim');
  }
})();
